import PropTypes from "prop-types";
import { StyledAppModal } from "./index.styled";
import { Flex, Typography } from "antd";
import { MdOutlineCancel } from "react-icons/md";

const AppModal = (props) => {
  const {
    onClose,
    open = false,
    width = 350,
    title,
    subtitle,
    children,
  } = props;
  return (
    <StyledAppModal
      open={open}
      centered
      footer={null}
      closable={false}
      width={width}
      destroyOnClose={true}
      onClose={onClose}
    >
      <Flex gap={16} vertical justify="center" align="center">
        <Flex gap={12} vertical justify="center" align="center">
          <MdOutlineCancel size={24} onClick={onClose} />
          <Title level={4}>{title}</Title>
          <Text type="secondary">{subtitle}</Text>
        </Flex>
        {children}
      </Flex>
    </StyledAppModal>
  );
};

const { Text, Title } = Typography;

AppModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  width: PropTypes.number,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AppModal;
